/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Business_Form_Success_Submit_AnotherInputs */

const en_business_form_success_submit_another = /** @type {(inputs: Business_Form_Success_Submit_AnotherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit another inquiry`)
};

const es_business_form_success_submit_another = /** @type {(inputs: Business_Form_Success_Submit_AnotherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar otra consulta`)
};

/**
* | output |
* | --- |
* | "Submit another inquiry" |
*
* @param {Business_Form_Success_Submit_AnotherInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const business_form_success_submit_another = /** @type {((inputs?: Business_Form_Success_Submit_AnotherInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Business_Form_Success_Submit_AnotherInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_business_form_success_submit_another(inputs)
	return en_business_form_success_submit_another(inputs)
});